import { Link } from 'react-router-dom';
import ArticleCard from '@/components/feature/ArticleCard';
import type { Article } from '@/mocks/articles';
import { stats } from '@/mocks/site';

interface HeroSectionProps {
  featured: Article;
  sideArticles: Article[];
}

export default function HeroSection({ featured, sideArticles }: HeroSectionProps) {
  return (
    <section className="px-4 md:px-6 pt-10 md:pt-14 pb-6">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-8">
        <div className="lg:col-span-4 flex flex-col">
          <span className="inline-flex items-center gap-2 text-xs font-label tracking-[0.28em] uppercase text-primary-700">
            <span className="w-6 h-px bg-primary-500" />
            独家揭秘 · 线报图解
          </span>
          <h1 className="mt-5 font-heading text-3xl md:text-[2.75rem] font-black leading-[1.15] text-foreground-950">
            揭秘局
            <span className="block mt-2 text-xl md:text-2xl font-bold text-foreground-700">
              把内幕拆成看得懂的图
            </span>
          </h1>
          <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed">
            同步独家线报、后续反映与深度内幕，把图解、信息图逐项整理。吃瓜党能快速抓最新线索变化，也可按图方便补全事件脉络，跟进每一波后续进展。
          </p>

          <div className="mt-7 grid grid-cols-2 gap-px bg-background-200/80 rounded-lg overflow-hidden border border-background-200/80">
            {stats.map((item) => (
              <div key={item.label} className="bg-background-50 p-4">
                <div className="font-heading text-xl md:text-2xl font-black text-primary-600">{item.value}</div>
                <div className="mt-1 text-xs text-foreground-500">{item.label}</div>
              </div>
            ))}
          </div>

          <div className="mt-7 flex flex-wrap items-center gap-3">
            <Link
              to="/feed"
              className="inline-flex items-center gap-2 h-11 px-6 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
            >
              进入线报库
              <i className="ri-arrow-right-line" />
            </Link>
            <Link
              to="/#subscribe"
              className="inline-flex items-center gap-2 h-11 px-6 rounded-md border border-foreground-950/15 text-foreground-900 text-sm font-medium whitespace-nowrap cursor-pointer hover:border-primary-400 hover:text-primary-600 transition-colors"
            >
              订阅每周整理信
            </Link>
          </div>
        </div>

        <div className="lg:col-span-8">
          <ArticleCard article={featured} variant="feature" />
        </div>
      </div>

      <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-6">
        {sideArticles.map((article) => (
          <ArticleCard key={article.id} article={article} />
        ))}
      </div>
    </section>
  );
}